import React from 'react';
import ReactDOM from 'react-dom/client';
import { TTSWidget } from './components/TTSWidget';
import './styles.css';

// Function to initialize the widget
const initializeTTSWidget = (targetElement, options = {}) => {
  const container = document.createElement('div');
  container.className = 'article-tts-widget-container';
  
  if (targetElement) {
    targetElement.appendChild(container);
    
    const root = ReactDOM.createRoot(container);
    root.render(
      <React.StrictMode>
        <TTSWidget
          articleContent={options.content || getArticleContent()}
          apiEndpoint={options.apiEndpoint || 'https://article-tts-api.ongrid.workers.dev'}
          voiceOptions={options.voiceOptions || { language: 'en-IN', voice: 'en-IN-Neural2-A' }}
          autoScroll={options.autoScroll !== undefined ? options.autoScroll : true}
          autoPlay={options.autoPlay !== undefined ? options.autoPlay : true}
        />
      </React.StrictMode>
    );
    
    return {
      container,
      destroy: () => {
        root.unmount();
        if (container.parentNode) {
          container.parentNode.removeChild(container);
        }
      }
    };
  }
  
  return null;
};

// Helper function to extract article content from the page
function getArticleContent() {
  // Default strategy: look for main content elements
  const contentSelectors = [
    'article',
    '[role="main"]',
    'main',
    '.article-content',
    '.post-content'
  ];
  
  let content = '';
  
  for (const selector of contentSelectors) {
    const element = document.querySelector(selector);
    if (element) {
      content = element.textContent;
      break;
    }
  }
  
  return content.trim();
}

// Make the widget available globally when included as a script
window.ArticleTTS = {
  init: initializeTTSWidget
};

// Export the component for ES module imports
export { TTSWidget, initializeTTSWidget }; 